
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Logo from "./Logo.vue"
import SidebarItem from "./SidebarItem.vue"
import variables from "@/assets/styles/variables.scss"

export default defineComponent({
    components: { SidebarItem, Logo },
    setup() {
        const store = useStore()
        const route = useRoute()

        const activeMenu = computed(() => {
            const { meta, path } = route
            // if set path, the sidebar will highlight the path you set
            if (meta.activeMenu) {
                return meta.activeMenu
            }
            return path
        })

        const showLogo = computed(() => store.state.settings.sidebarLogo)
        const settings = computed(() => store.state.settings)
        const sidebar = computed(() => store.state.app.sidebar)
        const sidebarRouters = computed(() => store.state.permission.sidebarRouters)

        const isCollapse = computed(() => !sidebar.value.opened)

        return {
            activeMenu,
            showLogo,
            variables,
            isCollapse,
            settings,
            sidebar,
            sidebarRouters
        }
    }
})
